export const t = {
  nav: {
    about: { pl: 'O nas', en: 'About', ua: 'Про нас' },
    services: { pl: 'Usługi', en: 'Services', ua: 'Послуги' },
    forCompanies: { pl: 'Dla firm', en: 'For Companies', ua: 'Для компаній' },
    contact: { pl: 'Kontakt', en: 'Contact', ua: 'Контакт' },
    cta: { pl: 'Skontaktuj się', en: 'Get in touch', ua: 'Зв\'яжіться' },
  },
  hero: {
    overline: { pl: 'Hirix Sp. z o.o.', en: 'Hirix Sp. z o.o.', ua: 'Hirix Sp. z o.o.' },
    title: {
      pl: 'Outsourcing procesowy dla przemysłu, logistyki i produkcji',
      en: 'Process outsourcing for industry, logistics and production',
      ua: 'Процесний аутсорсинг для промисловості, логістики та виробництва',
    },
    subtitle: {
      pl: 'Zapewniamy ciągłość operacji, elastyczne wsparcie i pełną koordynację procesów.',
      en: 'We ensure operational continuity, flexible support and full process coordination.',
      ua: 'Забезпечуємо безперервність операцій, гнучку підтримку та повну координацію процесів.',
    },
    cta: { pl: 'Skontaktuj się z nami', en: 'Contact us', ua: 'Зв\'яжіться з нами' },
  },
  about: {
    overline: { pl: 'O nas', en: 'About us', ua: 'Про нас' },
    title: {
      pl: 'Specjalizujemy się w organizacji procesów wspierających przemysł',
      en: 'We specialize in organizing processes that support industry',
      ua: 'Ми спеціалізуємося на організації процесів, що підтримують промисловість',
    },
    text1: {
      pl: 'Firma Hirix Sp. z o.o. specjalizuje się w organizacji i koordynacji procesów wspierających codzienne funkcjonowanie zakładów przemysłowych, produkcyjnych i logistycznych.',
      en: 'Hirix Sp. z o.o. specializes in organizing and coordinating processes that support the daily operations of industrial, production and logistics facilities.',
      ua: 'Hirix Sp. z o.o. спеціалізується на організації та координації процесів, що підтримують щоденне функціонування промислових, виробничих та логістичних підприємств.',
    },
    text2: {
      pl: 'Nasza misja to zwiększanie przewidywalności procesów, odciążanie firm od zadań operacyjnych i umożliwianie im koncentracji na kluczowych celach biznesowych.',
      en: 'Our mission is to increase process predictability, relieve companies of operational tasks and enable them to focus on key business objectives.',
      ua: 'Наша місія — підвищення передбачуваності процесів, звільнення компаній від операційних завдань та надання можливості зосередитися на ключових бізнес-цілях.',
    },
    values: {
      pl: ['Niezawodność', 'Elastyczność', 'Bezpieczeństwo operacyjne', 'Partnerskie podejście'],
      en: ['Reliability', 'Flexibility', 'Operational safety', 'Partnership approach'],
      ua: ['Надійність', 'Гнучкість', 'Операційна безпека', 'Партнерський підхід'],
    },
  },
  services: {
    overline: { pl: 'Usługi', en: 'Services', ua: 'Послуги' },
    title: {
      pl: 'Kompleksowe wsparcie operacyjne',
      en: 'Comprehensive operational support',
      ua: 'Комплексна операційна підтримка',
    },
    items: [
      {
        title: { pl: 'Outsourcing procesów produkcyjnych', en: 'Production process outsourcing', ua: 'Аутсорсинг виробничих процесів' },
        desc: {
          pl: 'Wsparcie linii produkcyjnych, obsługa zadań powtarzalnych i sezonowych. Dostarczamy wykwalifikowane zespoły dostosowane do specyfiki zakładu.',
          en: 'Production line support, handling repetitive and seasonal tasks. We provide qualified teams adapted to the specifics of the facility.',
          ua: 'Підтримка виробничих ліній, виконання повторюваних та сезонних завдань. Надаємо кваліфіковані команди, адаптовані до специфіки підприємства.',
        },
        icon: 'Cog',
      },
      {
        title: { pl: 'Outsourcing procesów logistycznych', en: 'Logistics process outsourcing', ua: 'Аутсорсинг логістичних процесів' },
        desc: {
          pl: 'Kompletacja, pakowanie, etykietowanie, obsługa magazynów. Pełna organizacja procesów logistycznych od przyjęcia do wysyłki.',
          en: 'Picking, packing, labeling, warehouse management. Full organization of logistics processes from receipt to dispatch.',
          ua: 'Комплектація, пакування, маркування, управління складами. Повна організація логістичних процесів від прийому до відправки.',
        },
        icon: 'Package',
      },
      {
        title: { pl: 'Wsparcie operacyjne 24/7', en: '24/7 operational support', ua: 'Операційна підтримка 24/7' },
        desc: {
          pl: 'Zespoły gotowe do pracy w trybie zmianowym. Zapewniamy ciągłość operacji niezależnie od pory dnia.',
          en: 'Teams ready to work in shifts. We ensure operational continuity regardless of the time of day.',
          ua: 'Команди, готові працювати позмінно. Забезпечуємо безперервність операцій незалежно від часу доби.',
        },
        icon: 'Clock',
      },
      {
        title: { pl: 'Koordynacja projektów operacyjnych', en: 'Operational project coordination', ua: 'Координація операційних проєктів' },
        desc: {
          pl: 'Zarządzanie zadaniami, raportowanie, optymalizacja. Kompleksowe prowadzenie projektów operacyjnych od planowania po realizację.',
          en: 'Task management, reporting, optimization. Comprehensive operational project management from planning to execution.',
          ua: 'Управління завданнями, звітність, оптимізація. Комплексне ведення операційних проєктів від планування до реалізації.',
        },
        icon: 'ClipboardList',
      },
      {
        title: { pl: 'Audyt i optymalizacja procesów', en: 'Process audit and optimization', ua: 'Аудит та оптимізація процесів' },
        desc: {
          pl: 'Analiza, usprawnienia, redukcja kosztów. Identyfikujemy wąskie gardła i wdrażamy rozwiązania zwiększające efektywność.',
          en: 'Analysis, improvements, cost reduction. We identify bottlenecks and implement solutions that increase efficiency.',
          ua: 'Аналіз, вдосконалення, зниження витрат. Виявляємо вузькі місця та впроваджуємо рішення для підвищення ефективності.',
        },
        icon: 'Search',
      },
      {
        title: { pl: 'Elastyczne zespoły zadaniowe', en: 'Flexible task teams', ua: 'Гнучкі робочі команди' },
        desc: {
          pl: 'Szybkie skalowanie zasobów w zależności od potrzeb. Reagujemy na zmienne zapotrzebowanie bez opóźnień.',
          en: 'Quick resource scaling depending on needs. We respond to variable demand without delays.',
          ua: 'Швидке масштабування ресурсів залежно від потреб. Реагуємо на змінний попит без затримок.',
        },
        icon: 'Users',
      },
    ],
  },
  forCompanies: {
    overline: { pl: 'Dla firm', en: 'For Companies', ua: 'Для компаній' },
    title: {
      pl: 'Dlaczego warto współpracować z Hirix Sp. z o.o.',
      en: 'Why partner with Hirix Sp. z o.o.',
      ua: 'Чому варто співпрацювати з Hirix Sp. z o.o.',
    },
    benefits: [
      { pl: 'Szybkie reagowanie na zmienne zapotrzebowanie', en: 'Quick response to variable demand', ua: 'Швидке реагування на змінний попит' },
      { pl: 'Pełna odpowiedzialność za proces', en: 'Full responsibility for the process', ua: 'Повна відповідальність за процес' },
      { pl: 'Redukcja kosztów operacyjnych', en: 'Reduction of operational costs', ua: 'Зниження операційних витрат' },
      { pl: 'Zwiększenie efektywności i przewidywalności', en: 'Increased efficiency and predictability', ua: 'Підвищення ефективності та передбачуваності' },
      { pl: 'Brak konieczności zatrudniania dodatkowych pracowników', en: 'No need to hire additional employees', ua: 'Немає потреби наймати додаткових працівників' },
    ],
    caseStudy: {
      title: { pl: 'Case Study', en: 'Case Study', ua: 'Кейс' },
      company: { pl: 'Zakład Przetwórstwa Mięsnego — Polska Centralna', en: 'Meat Processing Plant — Central Poland', ua: 'М\'ясопереробний завод — Центральна Польща' },
      desc: {
        pl: 'Zakład przetwórstwa mięsnego zlecił Hirix Sp. z o.o. obsługę procesów pakowania i etykietowania. W ciągu 6 miesięcy współpracy firma osiągnęła wymierne rezultaty.',
        en: 'A meat processing plant commissioned Hirix Sp. z o.o. to handle packaging and labeling processes. Within 6 months of cooperation, the company achieved measurable results.',
        ua: 'М\'ясопереробний завод доручив Hirix Sp. z o.o. обслуговування процесів пакування та маркування. За 6 місяців співпраці компанія досягла вимірних результатів.',
      },
      metrics: [
        { value: '32%', label: { pl: 'Redukcja kosztów operacyjnych', en: 'Operational cost reduction', ua: 'Зниження операційних витрат' } },
        { value: '2x', label: { pl: 'Szybsze skalowanie zespołów', en: 'Faster team scaling', ua: 'Швидше масштабування команд' } },
        { value: '99.4%', label: { pl: 'Ciągłość realizacji procesów', en: 'Process continuity rate', ua: 'Безперервність реалізації процесів' } },
        { value: '0', label: { pl: 'Przestojów w ciągu kwartału', en: 'Downtimes per quarter', ua: 'Простоїв за квартал' } },
      ],
    },
  },
  contact: {
    overline: { pl: 'Kontakt', en: 'Contact', ua: 'Контакт' },
    title: { pl: 'Porozmawiajmy o współpracy', en: "Let's talk about cooperation", ua: 'Поговоримо про співпрацю' },
    subtitle: {
      pl: 'Wypełnij formularz, a nasz zespół skontaktuje się z Tobą w ciągu 24 godzin.',
      en: 'Fill out the form and our team will contact you within 24 hours.',
      ua: 'Заповніть форму, і наша команда зв\'яжеться з вами протягом 24 годин.',
    },
    firstName: { pl: 'Imię', en: 'First name', ua: 'Ім\'я' },
    lastName: { pl: 'Nazwisko', en: 'Last name', ua: 'Прізвище' },
    companyName: { pl: 'Nazwa firmy', en: 'Company name', ua: 'Назва компанії' },
    message: { pl: 'Wiadomość', en: 'Message', ua: 'Повідомлення' },
    submit: { pl: 'Wyślij wiadomość', en: 'Send message', ua: 'Надіслати повідомлення' },
    success: { pl: 'Wiadomość wysłana pomyślnie!', en: 'Message sent successfully!', ua: 'Повідомлення успішно надіслано!' },
    error: { pl: 'Wystąpił błąd. Spróbuj ponownie.', en: 'An error occurred. Please try again.', ua: 'Сталася помилка. Спробуйте ще раз.' },
    companyInfo: 'HIRIX SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ',
    address: 'Aleja "Solidarności" 117 / 207\n00-140 Warszawa, Polska',
    email: 'biuro@hirix.pl',
  },
  footer: {
    rights: {
      pl: 'Wszelkie prawa zastrzeżone.',
      en: 'All rights reserved.',
      ua: 'Усі права захищені.',
    },
  },
};
